import { Divider, List, ListItem } from '@material-ui/core';
import { ArrowLeft, ArrowRight } from '@material-ui/icons';
import React from 'react';
import AppMenuMainItem from '../common/AppDrawerItem';
import { analyticEvent } from '../../../../../analytics';
import { connect } from 'react-redux';
import { compose } from 'redux';
import makeStyles from '@material-ui/core/styles/makeStyles';

const styles = makeStyles((theme) => ({
  listItemStyles: {
    height: 60,
    '&:hover': {
      backgroundColor: theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.06)' : 'rgba(255,255,255,0.08)',
    },
  },
}));

const AppDrawerComplexList = React.forwardRef(({
                                                 menuDefinition,
                                                 submenuOpened,
                                                 onClick,
                                                 onSubmenuClick,
                                                 user: { LicenseInfo: { Version } },
                                               }, ref) => {
  const classes = styles();
  return (
    <List ref={ref}>
      {menuDefinition.map((menuItemDefinition, index) => {
        if ('label' in menuItemDefinition) {
          return (
            <AppMenuMainItem
              key={index}
              menuItemDefinition={menuItemDefinition}
              isSubmenuOpened={submenuOpened === index}
              SubmenuOpenedIcon={ArrowLeft}
              SubmenuClosedIcon={ArrowRight}
              disabled={menuItemDefinition.disabled}
              onClick={event => {
                if ('submenu' in menuItemDefinition) {
                  onSubmenuClick(index);
                } else {
                  analyticEvent('Navigation Click', 'Open', menuItemDefinition.link);
                  onClick(event);
                }
              }}
            />
          );
        } else if ('object' in menuItemDefinition) {
          return menuItemDefinition.available?.includes(Version) ?
            <ListItem className={classes.listItemStyles} key={index}>
              {menuItemDefinition.object}
            </ListItem>
            : null;
        }
        return (
          <Divider key={menuItemDefinition.key} />
        );
      })}
    </List>
  );
});

export default compose(
  connect(store => ({
    user: store.user.profile,
  })),
)(AppDrawerComplexList);
